"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Orderable = void 0;
var Orderable = /** @class */ (function () {
    function Orderable() {
    }
    Orderable.prototype.orderByStart = function (other) {
        return this.left() < other.left() ? -1
            : this.left() > other.left() ? 1
                : 0;
    };
    Orderable.prototype.orderByEnd = function (other) {
        return this.right() > other.right() ? -1
            : this.right() < other.right() ? 1
                : 0;
    };
    return Orderable;
}());
exports.Orderable = Orderable;
